module.exports = __webpack_public_path__ + "img/living-or-sofa-sets.83bf693b.jpg";